/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mesafeli_S3_Third_BodyInputs */

const tr_mesafeli_s3_third_body = /** @type {(inputs: Mesafeli_S3_Third_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trendyol, Shopify, Hepsiburada, n11, QNB eSolutions, Sipay, Geliver, Cloudflare, Supabase, Resend ve diğer bağımsız sağlayıcılar.`)
};

const en_mesafeli_s3_third_body = /** @type {(inputs: Mesafeli_S3_Third_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trendyol, Shopify, Hepsiburada, n11, QNB eSolutions, Sipay, Geliver, Cloudflare, Supabase, Resend and other independent providers.`)
};

const de_mesafeli_s3_third_body = /** @type {(inputs: Mesafeli_S3_Third_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trendyol, Shopify, Hepsiburada, n11, QNB eSolutions, Sipay, Geliver, Cloudflare, Supabase, Resend und weitere unabhängige Anbieter.`)
};

const ru_mesafeli_s3_third_body = /** @type {(inputs: Mesafeli_S3_Third_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trendyol, Shopify, Hepsiburada, n11, QNB eSolutions, Sipay, Geliver, Cloudflare, Supabase, Resend и другие независимые поставщики.`)
};

/**
* | output |
* | --- |
* | "Trendyol, Shopify, Hepsiburada, n11, QNB eSolutions, Sipay, Geliver, Cloudflare, Supabase, Resend and other independent providers." |
*
* @param {Mesafeli_S3_Third_BodyInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const mesafeli_s3_third_body = /** @type {((inputs?: Mesafeli_S3_Third_BodyInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mesafeli_S3_Third_BodyInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_mesafeli_s3_third_body(inputs)
	if (locale === "de") return de_mesafeli_s3_third_body(inputs)
	if (locale === "ru") return ru_mesafeli_s3_third_body(inputs)
	return tr_mesafeli_s3_third_body(inputs)
});